import './waitingScreen.css';



function waitingScreen() {
  return (
    <>
    </>
  );
}
export default waitingScreen;



